module.exports = __webpack_public_path__ + "static/img/pic.0dc934c1.png";